import { useMemo } from 'react';

import useUserStore from '@/stores/UserStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';

const useUserRole = () => {
  const { user } = useUserStore((state) => ({ user: state.user }));
  const { currWorkspaceMembers } = useWorkspaceStore((state) => ({
    currWorkspaceMembers: state.currWorkspaceMembers,
  }));
  const userRole = useMemo(
    () =>
      currWorkspaceMembers.find((member) => member.email === user?.email)?.role,
    [user, currWorkspaceMembers],
  );

  const admin = useMemo(
    () =>
      currWorkspaceMembers.find((member) => member.email === user?.email)
        ?.admin || false,
    [user, currWorkspaceMembers],
  );

  const isInnerMember = useMemo(
    () => user?.email?.includes('@deepbluedot.io'),
    [user],
  );

  return {
    isEditor: userRole === 2,
    isViewer: userRole === 1,
    isAdmin: admin,
    isInnerMember,
  };
};

export default useUserRole;
